import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/img/select2-title.png'
import _imports_1 from '@/assets/img/select2-btn.png'
import _imports_2 from '@/assets/img/xf.png'


const _hoisted_1 = { class: "select2-wrapper" }
const _hoisted_2 = { class: "select-box" }
const _hoisted_3 = /*#__PURE__*/_createVNode("div", { class: "select-title" }, [
  /*#__PURE__*/_createVNode("img", { src: _imports_0 })
], -1)
const _hoisted_4 = { class: "scroll-container" }
const _hoisted_5 = {
  class: "transform-container",
  ref: "scroll"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("img", { src: _imports_1 }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("div", { class: "select-xiaofeng" }, [
  /*#__PURE__*/_createVNode("img", { src: _imports_2 })
], -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode("div", _hoisted_4, [
        _createVNode("div", _hoisted_5, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.scrollText, (item, index) => {
            return (_openBlock(), _createBlock("div", {
              key: index,
              class: "scroll-text"
            }, [
              (item>=0)
                ? (_openBlock(), _createBlock("img", {
                    key: 0,
                    src: require(`@/assets/img/text/text${item}.png`)
                  }, null, 8, ["src"]))
                : _createCommentVNode("", true)
            ]))
          }), 128))
        ], 512)
      ]),
      _createVNode("div", {
        class: ["select-begin btn", _ctx.showBtn && 'show'],
        onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goWrite && _ctx.goWrite(...args)))
      }, [
        _hoisted_6
      ], 2),
      _hoisted_7
    ])
  ]))
}